import { render, staticRenderFns } from "./BaseBeam.vue?vue&type=template&id=70365ff0&scoped=true&"
import script from "./BaseBeam.vue?vue&type=script&lang=js&"
export * from "./BaseBeam.vue?vue&type=script&lang=js&"
import style0 from "./BaseBeam.vue?vue&type=style&index=0&id=70365ff0&scoped=true&lang=scss&"
import style1 from "./BaseBeam.vue?vue&type=style&index=1&id=70365ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70365ff0",
  null
  
)

export default component.exports